import {useEffect, useState} from "react";
import * as util from "../Helpers/Util";
import queryString from "query-string";
import history from "../../history";
import isimDegisiklikKonuSorgula from "../../services/isimDegisiklikKonuSorgula";
import basvuruIsimDegisiklikKonuSorgula from "../../services/basvuruIsimDegisiklikKonuSorgula";
import basvuruIsimDegisiklikKonuGuncelle from "../../services/basvuruIsimDegisiklikKonuGuncelle";
import {
    Form,
    Select,
    Col,
    Button,
    Row,
    Spin
} from "antd";
const {Option} = Select;

const parsed = queryString.parse(history.location.search);

const formItemStyle = {
    marginLeft: 20,
    marginTop: 20
};

const BasvuruIsimDegisiklikForm = () => {
    const [form] = Form.useForm();
    const [spining, setSpining] = useState(false);
    const [isimDegisiklikKonuList, setIsimDegisiklikKonuList] = useState();
    const [basvuruIsimDegisiklikKonuIdList,setBasvuruIsimDegisiklikKonuIdList] = useState([]);
    const [formReadonly, setFormReadonly] = useState(false);
   
    const loadForm = async () => {
        setSpining(true);
        await basvuruIsimDegisiklikKonuSorgula(parsed.parentObjectId).then((resp) => {
            if (resp.data.success) {
                setBasvuruIsimDegisiklikKonuIdList(resp.data.result.basvuruIsimDegisiklikKonuIdList);
                form.setFieldsValue({
                    IsimDegisiklikKonuIdList : resp.data.result.basvuruIsimDegisiklikKonuIdList
                }); 
                form.getFieldsValue(); 
                setFormReadonly(resp.data.result.isReadonly);
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch((ex) => {
            util.errorMessage(String(ex.message));
        });

        await isimDegisiklikKonuSorgula().then((resp) => {
            if (resp.data.success) {
                setIsimDegisiklikKonuList(resp.data.result);
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch((ex) => {
            util.errorMessage(String(ex.message));
        });
        
        setSpining(false);
    };
    useEffect(() => {
        loadForm();
    }, []);

    const onFinish = async () => {
        setSpining(true);
        var data = {
            objectId: parsed.parentObjectId,
            isimDegisiklikKonuIdList: basvuruIsimDegisiklikKonuIdList
        };
        await basvuruIsimDegisiklikKonuGuncelle(data).then(resp => {
            if (resp.data.success) {
                util.successMessage(resp.data.message);
                window.parent.location.reload();    
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch(ex => {
            util.errorMessage(String(ex.message))
        });
        setSpining(false);

    };

    return (
        <Spin tip={"Veriler Yükleniyor"}
            spinning={spining}>
            <Form form={form}
                onFinish={onFinish}
              
                >
                <Col span={20}>
                    <Form.Item label="İsim Değişiklik Konu" name="IsimDegisiklikKonuIdList"
                       
                        style={formItemStyle}
                        labelAlign="left">
                        {
                            <Select mode="tags" placeholder="İsim Değişiklik Konu"
                                onChange = {(val) => setBasvuruIsimDegisiklikKonuIdList(val)}
                                disabled={formReadonly}>
                                {
                                isimDegisiklikKonuList && isimDegisiklikKonuList.map((bt) => (
                                    <Option key={
                                            bt.objectid
                                        }
                                        value={
                                            bt.objectid
                                    }>
                                        {
                                        bt.adi
                                    } </Option>
                                ))
                            } </Select>

                           

                    }
                     </Form.Item>
                </Col>
                <Row>
                    <Col span={20}
                        style={
                            {textAlign: "right"}
                    }>
                        <Button type="primary" htmlType="submit">
                            Güncelle
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Spin>
    );
};

export default BasvuruIsimDegisiklikForm;

